import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

const deleteListingVideo =
  (makeCall: MakeCall) => (listingId: number, videoId: number) =>
    makeCall<undefined>(
      'DELETE',
      `${APIV2_URL}/listing/${listingId}/video/${videoId}`,
    );

export default deleteListingVideo;
